/**
 * CollapsedRail — public entry point for the Closed area's collapsed state
 * (SE-6862).
 *
 * Pure presentation with no state of its own, so it ships as a View with no
 * Container. Nested under the ClosedArea organism rather than promoted to its
 * own molecule directory: it has exactly one consumer and no meaning outside
 * the Closed area, the same reason ClosedCardRow sits here.
 * @module features/player-kanban/components/organisms/ClosedArea/CollapsedRail
 */

export { default } from "./CollapsedRailView";
export type { CollapsedRailViewProps } from "./CollapsedRailView";
